export default __webpack_public_path__ + "static/media/placeholder.bc99f14b.svg";